/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { acosClamped as n } from "../../core/mathUtils.js";
import { d as t, l as o, a as r, n as s, c } from "../../chunks/vec3.js";
import { c as u } from "../../chunks/vec3f64.js";

function a(n, o, s) {
  var c = t(n, o) / t(n, n);
  return r(s, n, c);
}

function e(n, r) {
  return t(n, r) / o(n);
}

function f(r, s) {
  var c = t(r, s) / (o(r) * o(s));
  return -n(c);
}

function i(o, r, u) {
  s(m, o), s(h, r);
  var a = t(m, h),
      e = n(a),
      f = c(m, m, h);
  return t(f, u) < 0 ? 2 * Math.PI - e : e;
}

var m = u(),
    h = u();
export { f as angle, i as angleAroundAxis, a as projectPoint, e as projectPointSignedLength };